module.exports = __webpack_public_path__ + "static/media/logo_red.7246a60a.png";